import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const generateReceipt = async ({
  businessName,
  saleDate,
  items,
  total,
  filenamePrefix = 'receipt'
}) => {
  const pdf = new jsPDF();
  const pageWidth = pdf.internal.pageSize.getWidth();

  // Header
  pdf.setFontSize(18);
  pdf.setFont('helvetica', 'bold');
  const businessTextWidth = pdf.getTextWidth(businessName);
  pdf.text(businessName, (pageWidth - businessTextWidth) / 2, 20);

  pdf.setFontSize(12);
  const receiptTitle = 'Sales Receipt';
  const receiptTitleWidth = pdf.getTextWidth(receiptTitle);
  pdf.text(receiptTitle, (pageWidth - receiptTitleWidth) / 2, 28);

  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(10);
  pdf.text(`Date: ${new Date(saleDate).toLocaleString()}`, 20, 35);

  // Separator
  pdf.setDrawColor(200);
  pdf.line(10, 38, pageWidth - 10, 38);

  // Table Header
  let y = 45;
  pdf.setFont('helvetica', 'bold');
  pdf.text('Item', 10, y);
  pdf.text('Qty', 80, y);
  pdf.text('Price', 110, y);
  pdf.text('Total', 160, y, { align: 'right' });

  y += 6;
  pdf.setFont('helvetica', 'normal');

  // Items
  items.forEach(item => {
    pdf.text(item.type, 10, y);
    pdf.text(item.quantity.toString(), 80, y);
    pdf.text(`Ksh${item.unitPrice.toFixed(2)}`, 110, y);
    pdf.text(`Ksh${(item.quantity * item.unitPrice).toFixed(2)}`, 160, y, { align: 'right' });
    y += 6;
  });

  // Dashed line
  y += 4;
  pdf.setDrawColor(150);
  pdf.setLineDashPattern([1, 1], 0);
  pdf.line(10, y, pageWidth - 10, y);
  y += 6;

  // Total
  pdf.setFont('helvetica', 'bold');
  pdf.text(`TOTAL:`, 110, y);
  pdf.text(`Ksh${total.toFixed(2)}`, 160, y, { align: 'right' });

  // Footer message
  y += 10;
  pdf.setFont('helvetica', 'italic');
  pdf.setFontSize(10);
  pdf.text('Thank you for shopping with us!', (pageWidth - pdf.getTextWidth('Thank you for shopping with us!')) / 2, y);

  // Save PDF
  const pdfFilename = `${filenamePrefix}-${Date.now()}.pdf`;
  pdf.save(pdfFilename);

  // JPEG (optional)
  const receiptDiv = document.getElementById('receipt-preview');
  if (receiptDiv) {
    const canvas = await html2canvas(receiptDiv);
    const jpegUrl = canvas.toDataURL('image/jpeg');
    const link = document.createElement('a');
    link.download = `${filenamePrefix}-${Date.now()}.jpeg`;
    link.href = jpegUrl;
    link.click();
  }
};
